<script>
  export let title
</script>

<div class='sidebarEntry'>
  <h3>{title}</h3>
  <div class='sidebarArea'>
    <slot/>
  </div>
  <slot name='footer'/>
</div>

<style>
  h3 {
    padding:0;
    margin:0;
    font-weight: bold;
    background: white;
    border-bottom:1px solid black;
    padding:4px;
  }

  .sidebarArea {
    padding: 8px;
  }

  .sidebarEntry {
    background-color:white;
    margin-bottom: 8px;
  }
</style>